import { render } from "./pageticketheader.vue?vue&type=template&id=60a88502"
import script from "./pageticketheader.vue?vue&type=script&lang=js"
export * from "./pageticketheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__